import React , {Component} from 'react';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import * as compose from 'lodash.flowright';
//styles and icons 
import { Paper , InputLabel , Typography , TextField, Button} from '@material-ui/core';
import { Row, Col } from 'react-bootstrap';

// this component respresents change password in profile 
class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCountryId: ''
        }
    }
    componentWillMount() {
    }
    checkPassword = (inputtxt) => {
        console.log(inputtxt)
        var passw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
        if (inputtxt.match(passw)) {
            this.setState({ ...this.state, errorMessage: '' });
            return true;
        }
        else {
            this.setState({ ...this.state, errorMessage: 'The password must contains at least 8 characters that are uppercase and lowercase letters , special characters and numbers.' });
            return false;
        }
    }
    changePassword = () => {
        let oldPassword = document.querySelector('#old').value;
        let newPassword =  document.querySelector("#new").value;
        if(this.checkPassword(newPassword)){
            this.props.change_password({
                variables : {
                    old : oldPassword,
                    new :  newPassword,
                }
            }).then(res => {

                if(res.data.Userupdate.Status.check){
                    document.querySelector('#old').value = '';
                    document.querySelector("#new").value = '';
                    this.setState({ ...this.state, successMessage: res.data.Userupdate.Status.message , errorMessage : ''});  
                }
                else{
                    this.setState({ ...this.state, errorMessage: res.data.Userupdate.Status.message , successMessage : ''});
                }
            })
        }
    }
    render() {
            return (
                <div className="saved-posts">
                    <Paper className="p-3 " style={{ borderTop: '2px solid #F27016', borderRadius: '0px'  , height : '450px'}}>
                        <Row >
                            <Col md={12}>
                                <Row className="m-0 mb-3 align-items-center">
                                    <Col className="text-left p-0">
                                        <h6 className="bold mb-0">
                                           Change Password
                                        </h6>
                                    </Col>
                                    <Col md={12} className="p-0 pt-3">
                                        <div className="mb-3">
                                            <InputLabel className="" htmlFor="old">
                                                <p className="mb-1"> Old Password</p>
                                            </InputLabel>
                                            <TextField
                                                required
                                                id="old"
                                                name="old"
                                                onChange={e => {
                                                    this.setState({...this.state , errorMessage : '' , successMessage : ''})
                                                }}
                                                className="p-0" 
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                        </div>
                                        <div className="mb-1">
                                            <InputLabel className="" htmlFor="new">
                                                <p className="mb-1"> New Password</p>
                                            </InputLabel>
                                            <TextField
                                                required
                                                id="new"
                                                name="new"
                                                onChange={e => {
                                                    this.setState({...this.state , errorMessage : '' , successMessage : ''})
                                                }}
                                                className="p-0"                                               
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} className="p-0">
                                            <Typography variant="subtitle1" className="text-danger">{this.state.errorMessage}</Typography>
                                    </Col>
                                    <Col xs={12} className="p-0">
                                            <Typography variant="subtitle1" className="text-success">{this.state.successMessage}</Typography>
                                    </Col>
                                    <Col xs={12} className="p-0 mt-3">
                                            <Button 
                                            onClick = {this.changePassword }
                                            size="small"
                                            variant="contained" 
                                            style={{fontSize : "0.9rem"}}
                                            className="btn-orange-gradiant pr-4 pl-4"> Change </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Paper>
                </div>
            ) 
        }
    }

const CHANGE_PASSWORD = gql`
mutation($old : String ! $new : Password !){
    Userupdate(data : {
      ChangePassword : {
            old : $old ,
                  new : $new ,
      }
    }){
      Status{
        code 
        message
        check
      }
    }
}
`;

export default compose(
    graphql(CHANGE_PASSWORD, {
        name: 'change_password'
    })
)(withRouter(ChangePassword))